import React from "react"
import PropTypes from "prop-types"
import { WarningButton } from "../../../components"
import styled from "styled-components"

const Container = styled.div`
  & .property {
    font-weight: bold;
  }
`
class IrrSampleInfo extends React.Component {
  state = {
    irrReviewer: "",
  }

  componentWillUpdate(nextProps) {
    const { irrSample } = nextProps
    const { irrReviewer } = irrSample
    if (this.state.irrReviewer !== irrReviewer) {
      this.setState({ irrReviewer })
    }
  }

  reassign = (periodId, sampleId) =>
    this.props.reassignReviewer(periodId, sampleId, this.state.irrReviewer)

  render() {
    const { reviewers, irrSample } = this.props
    const { nurse, id, periodId, period, irrType } = irrSample

    return (
      <Container>     
          <div>
            <div className="row">
              <div className="property col-sm-3">IRR Reviewer:</div>
              <div className="col-sm-3">
                <select
                  className="form-control"
                  onChange={(e) =>
                    this.setState({ irrReviewer: e.currentTarget.value })
                  }
                  value={this.state.irrReviewer}
                >
                  {reviewers.map((x) => (
                    <option
                      key={x.id}
                      value={`${x.firstName} ${x.lastName}`}
                    >{`${x.firstName} ${x.lastName}`}</option>
                  ))}
                </select>
              </div>
              <div className="col-sm-3">
                <WarningButton
                  style={{ width: 90 }}
                  onClick={() => this.reassign(periodId, id)}
                >
                  Reassign
                </WarningButton>
              </div>
            </div>
            <div className="row">
              <div className="property col-sm-3">Reviewed Nurse:</div>
              <div className="col-sm-9">{nurse}</div>
            </div>
            <div className="row">
              <div className="property col-sm-3">Period:</div>
              <div className="col-sm-9">{period ? period.description : ""}</div>
            </div>
            <div className="row">
              <div className="property col-sm-3">IRR Type:</div>
              <div className="col-sm-9">{irrType}</div>
            </div>
          </div>
      </Container>
    )
  }
}

IrrSampleInfo.propTypes = {
  reviewers: PropTypes.array.isRequired,
  irrSample: PropTypes.object.isRequired,
  reassignReviewer: PropTypes.func.isRequired
}

export default IrrSampleInfo



// WEBPACK FOOTER //
// ./src/modules/irr-sample/components/IrrSampleInfo.js